import { Lesson } from "@jelly/lesson";
import principle01 from "./layouts/principle-01/principle";
import task01 from "./layouts/task-01/task";
import task02 from "./layouts/task-02/task";
import task03 from "./layouts/task-03/task";

const lesson: Lesson = {
  id: "6dd03ad3-0ccb-41c1-a358-b993a05e2076",
  publicId: "6",
  name: "Radiation of simple acoustic sources",
  difficulty: 1,
  contentTypes: { audio: false, interactive: true, video: false },
  body: [principle01, task01, task02, task03],
};

export default lesson;
